import { MdMarkEmailUnread, MdOutlineCancel } from "react-icons/md";
import { ListPicker } from "../../components/generic/ListPicker";
import { usePickerhook } from "../../hooks/usePickerhook";
import { IoMdEye, IoMdMore } from "react-icons/io";
import useNotificationHook from "../../hooks/useNotificationHook";
import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react/jsx-runtime";
import { GoDotFill } from "react-icons/go";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
import { LuUser } from "react-icons/lu";

const NotificationsActivity = () => {
  const rolepicked = usePickerhook();
  const { userNotifications } = useNotificationHook();

  return (
    <div>
      <div className="flex justify-between items-center w-full ">
        <p className="text-sm font-semibold">
          Notifications ({userNotifications.length})
        </p>{" "}
        <ListPicker hook={rolepicked} notitle title="Company" list={[]} />
      </div>

      {userNotifications.map((note) => (
        <NotiicationItem item={note} />
      ))}
    </div>
  );
};
export { NotificationsActivity };

const NotiicationItem = ({ item }) => {
  const { setShowModal, showModal } = useStateSetter();

  const ViewNoteModal = () => {
    return (
      <div className="flex flex-col justify-start w-full items-star ">
        <p className="font-semibold w-full flex justify-between text-sm">
          {item.title}
          <MdOutlineCancel
            onClick={() => setShowModal(false)}
            size={20}
            className="text-gray-400"
          />
        </p>
        <p className="text-sm w-full my-2">
          {" "}
          <GoDotFill
            size={15}
            className={` text-[#F79009]
                
            }  ${item.status.includes("In-Progress") ? "text-blue-400" : ""}  ${
              item.status.includes("Completed") ? "text-green-400" : ""
            } inline `}
          />
          {item.status}
        </p>

        <div className="flex mt-2 flex-col  w-full">
          <div className="flex">
            <LuUser
              className="  p-2 rounded-full bg-faintBlue  text-textbg"
              size={50}
            />
            <div className="m-2  ">
              <p className="font-semibold text-sm">Notification </p>
              <p className="font-light text-xs">{item.message}</p>
            </div>
          </div>

          <div className="p-3 bg-gray-100 px-4 w-full rounded">
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium ">Notification </span>
              <span className="font-medium capitalize">{item.target}</span>
            </p>
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium "> Date</span>
              <span className="font-medium">
                {new Date(item.updatedAt).toDateString()}
              </span>
            </p>
          </div>
          <div></div>
        </div>
      </div>
    );
  };

  return (
    <div className="flex rounded-lg border justify-between p-4 m-2  ">
      <p
        onClick={() => {
          showModal("", "", "", <ViewNoteModal />);
        }}
        className="truncate text-gray-700 font-semibold cursor-pointer  flex   items-center  "
      >
        <MdMarkEmailUnread size={20} className="inline " />
        <p className="w-[60%] overflow-x-hidden truncate inline-block">
          {" "}
          {item.message}
        </p>
        <span className="font-light text-xs ">
          {new Date(item.updatedAt).toDateString()}
        </span>
      </p>

      <Menu as="div" className={`relative my-2 `}>
        <Menu.Button className="   w-full  ">
          <IoMdMore size={20} className="text-textbg " />
        </Menu.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            onClick={() => {}}
            className="origin-top-left z-10 absolute right-0 mt-2 rounded-sm shadow-md p-1 bg-white w-full  max-h-[200px] min-w-[150px]   overflow-x-hidden overflow-y-scroll ring-1 ring-black ring-opacity-5 focus:outline-none"
          >
            <Menu.Item>
              <p
                onClick={() => {}}
                className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
              >
                <IoMdEye className="inline" /> mark as read
              </p>
            </Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};
